import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.6 2.34H4.44a2.75 2.75 0 0 0-2.75 2.75v6a2.75 2.75 0 0 0 2.75 2.75h7.16a2.75 2.75 0 0 0 2.75-2.75v-6a2.75 2.75 0 0 0-2.75-2.75Zm-7.16 1.5h7.16a1.23 1.23 0 0 1 1.21 1L8 7.57 3.23 4.81a1.23 1.23 0 0 1 1.21-.97Zm8.41 7.22a1.25 1.25 0 0 1-1.25 1.25H4.44a1.25 1.25 0 0 1-1.25-1.25V6.52l4.45 2.56a.75.75 0 0 0 .38.1.69.69 0 0 0 .37-.1l4.46-2.57Z';
const draw24px =
  'M19,3.25H5.05A2.75,2.75,0,0,0,2.3,6V18a2.75,2.75,0,0,0,2.75,2.75H19A2.75,2.75,0,0,0,21.7,18V6A2.75,2.75,0,0,0,19,3.25ZM3.8,6A1.25,1.25,0,0,1,5.05,4.75H19A1.25,1.25,0,0,1,20.2,6V7L12,11.71,3.8,7ZM20.2,18A1.25,1.25,0,0,1,19,19.25H5.05A1.25,1.25,0,0,1,3.8,18V8.72l7.82,4.51a.86.86,0,0,0,.38.1.79.79,0,0,0,.37-.1L20.2,8.72Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const EnvelopeIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'envelope'),
) as IconWithRender;

EnvelopeIcon.displayName = 'EnvelopeIcon';
EnvelopeIcon.propTypes = Icon.propTypes;
EnvelopeIcon.renderIcon = (props) => <EnvelopeIcon {...props} />;
export default EnvelopeIcon;
